import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {Tooltip} from "@mui/material";

import {TileCardT} from "@components/layout/TileCard.type";

interface propsT {
  isAuthorized: boolean;
  card: TileCardT;
}

const debug = false;

const TileCard = (props: propsT) => {
  const { isAuthorized, card } = props;
  debug && console.log("TileCard", props);

  const getCardContent = (active, card) => {
    return(
      <Content active={active}>
        <Header>{card.title}</Header>
        <Icon>{card.icon}</Icon>
        <Description>{card.description}</Description>
        { card.newTab ? <Warning active={active}>External Link</Warning> : null }
      </Content>
    )
  }

  const active = !card.authorizedOnly || isAuthorized ? 'active' : 'not-active';
  debug && console.log("card.authorizedOnly", card.authorizedOnly,
      " active:", active);
  // return an inactive button
  if (!active) {
    return (
        <StyledCard active={active==='active'}>
          <Link to={card.link}>
            { getCardContent(active, card) }
          </Link>
        </StyledCard>
    )
  }
  // have as coming soon
  if (card.link === '') {
    return (
      <StyledCard active={false}>
        <Tooltip
          title={'Coming Soon'}
          arrow
          placement={'top-start'}
        >
          {getCardContent(false, card)}
        </Tooltip>
      </StyledCard>
    );
  }
  // handle whether internal link or external
  if (card.newTab) {
    return (
      <StyledCard active={active==='active'}>
        <a href={card.link} target = "_blank" rel = "noopener noreferrer">
          { getCardContent(active, card) }
        </a>
      </StyledCard>
    );
  } else {
    return(
      <StyledCard active={active==='active'}>
        <Link to={card.link}>
          { getCardContent(active, card) }
        </Link>
      </StyledCard>
    );
  }
}

export default TileCard;

const StyledCard = styled.div<{active: boolean}>`
  display: flex;
  height: 150px;
  width: 220px;
  margin: 4px;
  padding: 6px;
  border-radius: 20px;
  opacity: ${(p) => p.active  ? 1.0: 0.5};
  background-color: ${(p)=> p.active  ? 
          p.theme.palette.backgroundTertiary : p.theme.palette.backgroundQuaternary };
  &:hover {
    background-color: ${(p)=> p.theme.palette.backgroundQuaternary };
  }
`;

const Content = styled.div<{active: string}>`
  position: relative;
  display: flex;
  height: 140px;
  width: 210px;
  padding: 5px;
  align-items: center;
  flex-direction: column;
  border: 1px solid ${(p) => p.theme.palette.accentSecondary };
  border-radius: 15px;
  &:hover {
    border: 1px solid ${(p)=> p.active === 'active' ?
            p.theme.palette.accentPrimary : p.theme.palette.accentSecondary };;
  }
`;

const Header = styled.div`
  display: flex;
  white-space: nowrap;
  font-size: 16px;
  min-height: 36px;
  justify-content: center;
  text-align: center;
`;

const Icon = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const Description = styled.div`
  padding-top: 5px;
  text-align: center;
  font-size: ${(p) => p.theme.sizes.xsmall };
  line-height: ${(p) => p.theme.sizes.small };
  color: ${(p) => p.theme.palette.textSecondary };
`;

const Warning = styled.div<{active: boolean}>`
  position: absolute;
  bottom: -7.5px;
  padding: 2px 5px;
  line-height: 12px;
  text-align: center;
  font-style: italic;
  font-size: ${(p) => p.theme.sizes.xsmall};
  color: ${(p) => p.theme.palette.accentSecondary};
  background-color: ${(p) =>
          p.active
                  ? p.theme.palette.backgroundTertiary
                  : p.theme.palette.backgroundQuaternary};
`;
